import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { frontendRoutes } from "../utility/frontendRoutes";

const COPY = {
  product: {
    emoji: "🕵️",
    title: "We looked everywhere. Twice.",
    body: "This product has either been removed or never existed in the first place. 👀",
  },
  shop: {
    emoji: "🔍",
    title: "We can't find this shop.",
    body: "This shop went to buy garri and has not come back.",
  },
  user: {
    emoji: "👻",
    title: "No one here but us.",
    body: "This profile has vanished.",
  },
  default: {
    emoji: "🤷",
    title: "Nothing to see here.",
    body: "Whatever you were looking for has gone missing. Only cobwebs remain.",
  },
};

// 404 — entity doesn't exist or was deactivated/suspended
export const NotFoundPage = ({ variant }) => {
  const copy = COPY[variant] || COPY.default;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 400,
        px: 4,
        textAlign: "center",
      }}
    >
      <Typography fontSize={56} sx={{ mb: 2, lineHeight: 1 }}>{copy.emoji}</Typography>
      <Typography variant="h6" fontWeight={700} color="#374151" sx={{ mb: 1 }}>
        {copy.title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4, maxWidth: 380, lineHeight: 1.7 }}>
        {copy.body}
      </Typography>
      <Button
        component={Link}
        to={frontendRoutes.HOME}
        variant="contained"
        sx={{ bgcolor: "#046287", "&:hover": { bgcolor: "#035070" }, borderRadius: 2, textTransform: "none", fontWeight: 700 }}
      >
        Back to home
      </Button>
    </Box>
  );
};

// Non-404 error — server error, network issue, etc.
export const ErrorPage = ({ refetch, variant }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 400,
      px: 4,
      textAlign: "center",
    }}
  >
    <Typography fontSize={52} sx={{ mb: 2, lineHeight: 1 }}>😬</Typography>
    <Typography variant="h6" fontWeight={700} color="#374151" sx={{ mb: 1 }}>
      Something went wrong
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 4, maxWidth: 360, lineHeight: 1.7 }}>
      Our servers are having a bad market day 🫠. Please try again.
    </Typography>
    {refetch && (
      <Button
        onClick={refetch}
        variant="contained"
        sx={{ bgcolor: "#046287", "&:hover": { bgcolor: "#035070" }, borderRadius: 2, textTransform: "none", fontWeight: 700 }}
      >
        Retry
      </Button>
    )}
  </Box>
);

// Single entry-point: picks NotFoundPage on 404, ErrorPage otherwise
// errorStatus is taken from error.status (Axios response object shape from appAxios)
const EntityErrorPage = ({ errorStatus, refetch, variant }) => {
  if (errorStatus === 404) return <NotFoundPage variant={variant} />;
  return <ErrorPage refetch={refetch} variant={variant} />;
};

export default EntityErrorPage;
